import { Children, type FC, type ReactNode } from "react";
import cx from "classnames";

import styles from "./SettingsList.module.css";

type Props = {
  className?: string;
  title?: ReactNode;
  children: ReactNode;
};

/**
 * Settings list
 */
export const SettingsList: FC<Props> = ({ className, title, children }) => {
  return (
    <div className={cx(styles.root, className)}>
      {title && <h3 className={styles.title}>{title}</h3>}
      <ul className={cx(styles.list, className)}>
        {Children.map(children, (child, i) => (
          <li className={styles.item} key={i}>{child}</li>
        ))}
      </ul>
    </div>
  );
};
